<div class="modal-content" *ngIf="showModal">
  <h3 class="bold center" mat-dialog-title>ES-CUT設定</h3>

  <mat-dialog-content>
    <div class="center">
      <canvas id="canvasQr"></canvas>
    </div>
  </mat-dialog-content>
  <p>AES-CUTに <br />読ませてください</p>
  <mat-dialog-actions>
    <button
      class="submitBtn"
      type="button"
      readonly="readonly"
      (click)="onClick('ok')"
    >
      閉じる
    </button>
  </mat-dialog-actions>
</div>
